import { render, staticRenderFns } from "./decrease.vue?vue&type=template&id=21cd2cdc"
import script from "./decrease.vue?vue&type=script&lang=js"
export * from "./decrease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports